/**
 * Espaces Humains : la version des stands, servie à part (hu.hoa.city).
 *
 * Même serveur, même code : c'est l'adresse qui décide. Pour l'essayer
 * ailleurs (localhost), `?eh=1` l'allume sur l'appareil et `?eh=0` l'éteint.
 */
const CLE = "eh.mode";

function calculer(): boolean {
  if (typeof location === "undefined") return false;
  if (/^hu\./i.test(location.hostname)) return true;
  try {
    const q = new URLSearchParams(location.search).get("eh");
    if (q === "1") localStorage.setItem(CLE, "1");
    if (q === "0") localStorage.removeItem(CLE);
    return localStorage.getItem(CLE) === "1";
  } catch {
    return false;
  }
}

export const ESPACES_HUMAINS = calculer();

/**
 * L'entrée par le QR code d'un événement : `/e/<id>`. Rend l'identifiant et
 * remet l'adresse à la racine (un rechargement ne refait pas l'entrée).
 */
export function entreeParQr(): string | null {
  if (typeof location === "undefined") return null;
  const m = /^\/e\/([^/?#]+)\/?$/.exec(location.pathname);
  if (!m) return null;
  try {
    history.replaceState(null, "", "/" + location.search);
  } catch {
    /* l'adresse reste telle quelle : sans conséquence */
  }
  return decodeURIComponent(m[1]!);
}
